import { giveawayModuleIds } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const redeemConfirmationModalModule = {
    [giveawayModuleIds.REDEEM_CONFIRMATION_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
